export default "__VITE_ASSET__934bc803__"